module.exports = __webpack_public_path__ + "static/media/dogCat.755a775d.png";